import {
  AxiosAction,
  isSuccessActionOf
} from '../middleware/axios';
import { isAction } from '../utils';

export interface LocationName {
  id: {
    entityId: string;
    version: number
  };
  breadcrumbs: Array<{
    entityId: string;
    name: string;
  }>;
  name: string;
}

export interface LocationNameBackendResponse {
  name: string;
  id: {
    entityId: string;
  };
}
export interface LocationNamesBackendResponse {
  _embedded: LocationName[];
}

// Action Types

const GET_LOCATION_NAMES = 'LOCATION.GET_NAMES';
const GET_LOCATION_NAME = 'LOCATION.GET_NAME';

// Action Interfaces

export interface GetLocationName extends AxiosAction<LocationNameBackendResponse> {
  type: typeof GET_LOCATION_NAME;
}
export interface GetLocationNames extends AxiosAction<LocationNamesBackendResponse> {
  type: typeof GET_LOCATION_NAMES;
}

// Action Creators

export function getLocationNames(
  text: string,
  limit: number
): GetLocationNames {
  const regexEscapedText = text.toLowerCase().replace(/[-[\]{}()*+?.,\\/^$|#\s]/g, '\\$&');
  const regex = new RegExp(regexEscapedText, 'i');

  return {
    payload: {
      client: 'backend',
      request: {
        method: 'get',
        params: {
          filter: JSON.stringify({
            fields: {
              // We don't care about this but the backend returns a 500 if we don't include it (sigh)
              _descendants: true,
              breadcrumbs: true,
              id: true,
              name: true
            },
            limit,
            order: 'name ASC',
            where: {
              name: {regexp: regex.toString()}
            }
          })
        },
        url: '/locations'
      }
    },
    type: GET_LOCATION_NAMES
  };
}
export const isGetLocationNames = isAction<GetLocationNames>(GET_LOCATION_NAMES);
export const isGetLocationNamesSuccess = isSuccessActionOf<GetLocationNames>(GET_LOCATION_NAMES);

export function getLocationName(code: string): GetLocationName {
  return {
    payload: {
      client: 'backend',
      request: {
        method: 'get',
        params: {
          filter: JSON.stringify({
            fields: {
              // We don't care about this but the backend returns a 500 if we don't include it (sigh)
              _descendants: true,
              breadcrumbs: true,
              id: true,
              name: true
            }
          })
        },
        url: `/locations/${code}/latest`
      }
    },
    type: GET_LOCATION_NAME
  };
}
export const isGetLocationName = isAction<GetLocationName>(GET_LOCATION_NAME);
export const isGetLocationNameSuccess = isSuccessActionOf<GetLocationName>(GET_LOCATION_NAME);
